import React from "react";
import { Helmet } from "react-helmet";
import Features from "../features/index.jsx";

import ReactTooltip from "react-tooltip";
const STATIC_PAGE_PATH =
  process.env.CMC_PORTAL_STATIC_PAGE_ABSOLUTE_PATH || "/";
const AUTHENTICATED_PAGE_PATH =
  process.env.CMC_PORTAL_AUTHENTICATED_PAGE_ABSOLUTE_PATH || "/";

class PricingPage extends React.Component {
  render() {
    return (
      <section className="section-pricing container">
        <Helmet>
          <title>CoinMarketCap API Pricing Plans</title>
        </Helmet>
        <div className="px-3 py-3 pt-md-5 pb-md-5 mx-auto text-center">
          <h1 className="display-4">Pricing</h1>
        </div>

        <div className="container">
          <div className="card-deck mb-3 text-center">
            <div className="card mb-4 box-shadow">
              <div className="card-header">
                <h4 className="my-0">Basic</h4>
                <p>Basic personal use</p>
              </div>
              <div className="card-body">
                <h1 className="card-title pricing-card-title">Free</h1>
                <p>
                  <small className="text-muted">No subscription required</small>
                </p>
                <a
                  href={AUTHENTICATED_PAGE_PATH + "signup/?plan=0"}
                  className="btn btn-outline-secondary text-uppercase"
                >
                  Get Free API Key
                </a>
                <ul className="list-unstyled mt-0 mb-0">
                  <li
                    className="tooltip-trigger"
                    data-tip="<ul class='tooltip-ul'><li>Cryptocurrency referential info and logo assets</li><li>Exchange referential info and logo assets</li><li>Latest cryptocurrency rankings and market quotes</li><li>Latest global market cap, volume, and stats</li><li>Latest crypto and fiat currency conversions</li><li>Partner data access</li><li>Cryptocurrencies by category</li></ul>"
                    data-html={true}
                  >
                    9 latest market data endpoints{" "}
                    <em className="fa fa-question-circle"></em>
                  </li>
                  <li>10K call credits /mo</li>
                  <li>No historical data</li>
                  <li>Personal use</li>
                </ul>
              </div>
            </div>
            <div className="card mb-4 box-shadow">
              <div className="card-header">
                <h4 className="my-0">Hobbyist</h4>
                <p>Personal projects</p>
              </div>
              <div className="card-body">
                <h1 className="card-title pricing-card-title">
                  $29<small className="text-muted">/ mo</small>
                  <br />
                </h1>
                <p>
                  <small className="text-muted">
                    Billed annually or $35 / mo
                  </small>
                </p>
                <a
                  href={AUTHENTICATED_PAGE_PATH + "signup/?plan=0.5"}
                  className="btn btn-outline-secondary text-uppercase"
                >
                  Get Started Now
                </a>
                <ul className="list-unstyled mt-0 mb-0">
                  <li
                    className="tooltip-trigger"
                    data-tip="<ul class='tooltip-ul'><li>Cryptocurrency referential info and logo assets</li><li>Exchange referential info and logo assets</li><li>Latest cryptocurrency rankings and market quotes</li><li>Latest global market cap, volume, and stats</li><li>Latest crypto and fiat currency conversions + 1 month historical</li><li>Partner data access</li><li>Cryptocurrencies by category</li><li>Cryptocurrency Airdrop Information</li></ul>"
                    data-html={true}
                  >
                    9 latest market data endpoints{" "}
                    <em className="fa fa-question-circle"></em>
                    <i className="fa fa-circle green"></i>
                  </li>
                  <li>110K call credits /mo</li>
                  <li>12 months of historical data</li>
                  <li>Personal use</li>
                </ul>
              </div>
            </div>
            <div className="card mb-4 box-shadow">
              <div className="card-header">
                <h4 className="my-0">Startup</h4>
                <p>For commercial use</p>
              </div>
              <div className="card-body">
                <h1 className="card-title pricing-card-title">
                  $79<small className="text-muted">/ mo</small>
                  <br />
                </h1>
                <p>
                  <small className="text-muted">
                    Billed annually or $95 / mo
                  </small>
                </p>
                <a
                  href={AUTHENTICATED_PAGE_PATH + "signup/?plan=1"}
                  className="btn btn-outline-secondary text-uppercase"
                >
                  Get Started Now
                </a>
                <ul className="list-unstyled mt-0 mb-0">
                  <li
                    className="tooltip-trigger"
                    data-tip="<ul class='tooltip-ul'><li>Cryptocurrency referential info and logo assets</li><li>Exchange referential info and logo assets</li><li>Latest cryptocurrency OHLCV, rankings, and market quotes</li><li>Latest global market cap, volume, and stats</li><li>Latest crypto and fiat currency conversions</li><li>1 month historical conversions & cryptocurrency OHLCV</li><li>Price performance stats</li><li>Partner data access</li><li>Cryptocurrencies by category</li><li>Cryptocurrency Airdrop Information</li><li>Trending Cryptocurrency data</li></ul>"
                    data-html={true}
                  >
                    14 latest market data endpoints{" "}
                    <em className="fa fa-question-circle"></em>{" "}
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                  </li>
                  <li>
                    300K call credits /mo <i className="fa fa-circle green"></i>
                  </li>
                  <li>24 months of historical data</li>
                  <li>
                    <b>Commercial use*</b>
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                  </li>
                </ul>
              </div>
            </div>
            <div className="card mb-4 box-shadow">
              <div className="card-header">
                <h4 className="my-0">Standard</h4>
                <p>Suitable for most use cases</p>
              </div>
              <div className="card-body">
                <h1 className="card-title pricing-card-title">
                  $299<small className="text-muted">/ mo</small>
                </h1>
                <p>
                  <small className="text-muted">
                    Billed annually or $375 / mo
                  </small>
                </p>
                <a
                  href={AUTHENTICATED_PAGE_PATH + "signup/?plan=2"}
                  className="btn btn-outline-secondary text-uppercase"
                >
                  Get Started Now
                </a>
                <ul className="list-unstyled mt-0 mb-0">
                  <li
                    className="tooltip-trigger"
                    data-tip="<ul class='tooltip-ul'><li>Cryptocurrency referential info and logo assets</li><li>Exchange referential info and logo assets</li><li>Latest cryptocurrency rankings and market quotes</li><li>Latest global market cap, volume, and stats</li><li>Latest crypto and fiat currency conversions</li><li>Exchange rankings and volume</li><li>Exchange market pair data</li><li>All historical endpoint access (3 months back)</li><li>Price performance stats</li><li>Partner data access</li><li>Cryptocurrencies by category</li><li>Cryptocurrency Airdrop Information</li><li>Trending Cryptocurrency data</li></ul>"
                    data-html={true}
                  >
                    All market data endpoints{" "}
                    <em className="fa fa-question-circle"></em>{" "}
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                  </li>
                  <li>
                    1,200K call credits /mo{" "}
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                  </li>
                  <li>
                    60 months of historical data
                    <i className="fa fa-circle green"></i>
                  </li>
                  <li>
                    <b>Commercial use*</b>
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                  </li>
                </ul>
              </div>
            </div>
            <div className="card mb-4 box-shadow">
              <div className="card-header">
                <h4 className="my-0">Professional</h4>
                <p>Best for scaling crypto projects</p>
              </div>
              <div className="card-body">
                <h1 className="card-title pricing-card-title">
                  $699<small className="text-muted">/ mo</small>
                </h1>
                <p>
                  <small className="text-muted">
                    Billed annually or $875 / mo
                  </small>
                </p>
                <a
                  href={AUTHENTICATED_PAGE_PATH + "signup/?plan=3"}
                  className="btn btn-outline-secondary text-uppercase"
                >
                  Get Started Now
                </a>
                <ul className="list-unstyled mt-0 mb-0">
                  <li
                    className="tooltip-trigger"
                    data-tip="<ul class='tooltip-ul'><li>Cryptocurrency referential info and logo assets</li><li>Exchange referential info and logo assets</li><li>Latest cryptocurrency rankings and market quotes</li><li>Latest global market cap, volume, and stats</li><li>Latest crypto and fiat currency conversions</li><li>Exchange rankings and volume</li><li>Exchange market pair data</li><li>All historical data access up to 12 months back</li><li>Price performance stats</li><li>Partner data access</li><li>Cryptocurrencies by category</li><li>Cryptocurrency Airdrop Information</li><li>Trending Cryptocurrency data</li></ul>"
                    data-html={true}
                  >
                    All market data endpoints{" "}
                    <em className="fa fa-question-circle"></em>{" "}
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                  </li>
                  <li>
                    3M call credits /mo <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                  </li>
                  <li>
                    All time historical data
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                  </li>
                  <li>
                    <b>Commercial use*</b>
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                  </li>
                </ul>
              </div>
            </div>
            <div className="card mb-4 box-shadow">
              <div className="card-header">
                <h4 className="my-0">Enterprise</h4>
                <p>Funded and established projects</p>
              </div>
              <div className="card-body">
                <h1 className="card-title pricing-card-title pricing-title-inquire">
                  Inquire for pricing.
                </h1>
                <p>&nbsp;</p>
                <a
                  href={AUTHENTICATED_PAGE_PATH + "contact/"}
                  className="btn btn-lg btn-block btn-primary"
                >
                  Contact us
                </a>
                <ul className="list-unstyled mt-0 mb-0">
                  <li
                    className="tooltip-trigger"
                    data-tip="<ul class='tooltip-ul'><li>Cryptocurrency referential info and logo assets</li><li>Exchange referential info and logo assets</li><li>Latest cryptocurrency rankings and market quotes</li><li>Latest global market cap, volume, and stats</li><li>Crypto and fiat currency conversions</li><li>Exchange rankings and volume</li><li>Exchange market pair data</li><li>Custom all historical endpoint access</li><li>Price performance stats</li><li>Partner data access</li><li>Cryptocurrencies by category</li><li>Cryptocurrency Airdrop Information</li><li>Trending Cryptocurrency data</li></ul>"
                    data-html={true}
                  >
                    All market data endpoints{" "}
                    <em className="fa fa-question-circle"></em>
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                  </li>
                  <li>
                    Custom call limits <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                  </li>
                  <li>
                    Historical data from April 2013 to present
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                  </li>
                  <li>
                    <b>Custom license</b>
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                    <i className="fa fa-circle green"></i>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <p>
            <small className="text-muted">
              * For 1 product only, up to 100k users. See{" "}
              <a href={AUTHENTICATED_PAGE_PATH + "user-agreement-commercial/"}>
                Terms of Use
              </a>{" "}
              for more details.
            </small>
          </p>
          <Features/>
        </div>
      </section>
    );
  }
}

export default PricingPage;



// WEBPACK FOOTER //
// ./client/pages/main/pricing/index.jsx